import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AdminService } from 'src/app/services/admin.service';
import { AuthService } from 'src/app/services/auth.service';
import { SharedService } from 'src/app/services/sharedService';

@Component({
  selector: 'app-password-restore',
  templateUrl: './password-restore.component.html',
  styleUrls: ['./password-restore.component.css']
})
export class PasswordRestoreComponent implements OnInit {

  public username: string;
  public password: string;
  public email: string;
  public error: string;
  public emailSent = false;
  public smsSent = false;
  notifParam: any;
  public user = {}
  expired = false;
  verificationCode: any
  passwordChanged = false;
  repeatPassword = "";
  renew = false
  emailForm: UntypedFormGroup;
  emailError = false
  phoneError = false
  validPassword = true;
  resp
  constructor(public authService: AuthService, private activatedRoute: ActivatedRoute, 
    private fb: UntypedFormBuilder, public sharedService: SharedService
  ) { 
    this.emailForm = this.fb.group({
    email: ['', [Validators.email]],
    phone: ['']
  }, { validators: this.requireAtLeastOne('email', 'phone') });  
  }

  ngOnInit() {
    this.sharedService.getCountryTelCode().subscribe(conf => {
      const code = conf.code;                 // "+225"
      const numberFormat = conf.numberFormat; // "0\\d{9}$"
  
      const pattern = new RegExp(`^\\${code}${numberFormat}`);
  
      const phoneControl = this.emailForm.get('phone');
      phoneControl.setValidators([Validators.pattern(pattern)]);
      phoneControl.updateValueAndValidity();
    });
    this.activatedRoute.queryParams.subscribe(params => {
  
      this.verificationCode = params['vercode'];
      this.renew = params['renew']
      if (this.verificationCode)
      this.authService.getUserByVerCode(this.verificationCode).subscribe(result => {
        if (!result || result.data && result.data==='NO_SUCH_HASH_OR_EXPIRED'){
          this.error = 'ERRORS.NO_SUCH_HASH_OR_EXPIRED';
        }else{
          this.user['id'] = result.id
          this.user['password'] = ''
        }
      })
    });
   
  }

  hidePassword = true;

  togglePasswordVisibility() {
    this.hidePassword = !this.hidePassword;
  }
  requireAtLeastOne(controlName1, controlName2) {
    return (formGroup) => {
      const control1 = formGroup.get(controlName1);
      const control2 = formGroup.get(controlName2);
  
      if (!control1 || !control2) return null;
  
      const oneFilled = control1.value?.trim() || control2.value?.trim();
      if (!oneFilled) {
        control1.setErrors({ requiredOne: true });
        control2.setErrors({ requiredOne: true });
        return { requiredOne: true };
      } else {
        if (control1.hasError('requiredOne')) control1.setErrors(null);
        if (control2.hasError('requiredOne')) control2.setErrors(null);
        return null;
      }
    };
  }  
  async sendLink() {
    const email = this.emailForm.get('email')?.value;
    const phone = this.emailForm.get('phone')?.value;
  
    if (!email && !phone) {
      this.error = 'Please enter either email or phone number.';
      return;
    }
  
    try {
      if (email) {
        this.emailSent = true;
        this.resp = await this.authService.sendResetLink({ type: 'email', email }).toPromise();
        if(this.resp.message === 'EMAIL_ERROR'){
          this.emailError = true;
        }
      } else if (phone) {
        this.smsSent = true;
        this.resp = await this.authService.sendResetLink({ type: 'sms', phone }).toPromise();
        if(this.resp.message === 'PHONE_ERROR'){
          this.phoneError = true;
        }
      }
    } catch (error) {
      console.error('Error during password restore process:', error);
      this.error = 'ERRORS.SYSTEM_ERROR';
    }
  }

  async setPassword(){
    let result = await this.authService.verifyPasswordValidity(this.user['password']).toPromise()
    if(result.valid){
      let resp = await this.authService.updatePassword(this.user).toPromise()
      if (resp){
        if (resp.error){
          this.error = 'ERRORS.OLD_PASSWORD';
        }else{
          this.error = null
          this.passwordChanged = true
        }
      }else{
        this.error = 'ERRORS.SYSTEM_ERROR';
      }
    }else{
      this.validPassword = false;
    }
  }

  verifyPassword(){

  }
}
